export default __webpack_public_path__ + "static/media/default_artwork.f2255b23.png";